@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-datepicker'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="(control().errors && (control().dirty || control().touched)) || false">
    </form-label>
}

<p-datePicker
    [inputId]="id() + '-datepicker'"
    [formControl]="control()"
    [view]="view()"
    [dateFormat]="dateFormat()"
    [selectionMode]="selectionMode()"
    [readonlyInput]="readonlyInput()"
    [showClear]="showClear()"
    [showButtonBar]="showButtonBar()"
    [showIcon]="true"
    [placeholder]="placeholder() | translate"
    [appendTo]="'body'"
    [fluid]="true"
    [size]="size()"
    [iconDisplay]="'input'"
    [maxDate]="maxDateTodayUTC() ? endOfCurrentDayUTC : maxDate()"
    [minDate]="minDateTodayUTC() ? startOfCurrentDayUTC : minDate()"
    [invalid]="control().invalid && (control().dirty || control().touched)"
    (onClose)="onClose()"></p-datePicker>

@if (control().invalid && (control().dirty || control().touched)) {
    @for (error of getErrorKeys(control().errors); track error) {
        <form-error [text]="getErrorMessage(error)"></form-error>
    }
}
